import * as React from "react";

import useTranslations from "../../../hooks/useTranslations";
import { BuildingIcon } from "../../icons";
import Activity from "../ActivityPlate";
import { Text } from "@chakra-ui/react";
import { ActivityFragment, CompanyMinimalFragment } from '../../../graphql/generated/definitions';

interface CompanyUpdatedActivityProps {
  activity: CompanyUpdatedActivity;
}

type CompanyUpdatedActivity = ActivityFragment & {
  recipient: CompanyMinimalFragment;
  trackable: CompanyMinimalFragment;
};

export function isCompanyUpdatedActivity(
  q: ActivityFragment
): q is CompanyUpdatedActivity {
  return q.key === "company.updated";
}

interface CompanyUpdatedActivityProps {
  activity: CompanyUpdatedActivity;
}

export const CompanyUpdatedActivity: React.FC<CompanyUpdatedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="companyUpdatedActivity"
      visual={<BuildingIcon className="w-10 h-10 text-accent-500" />}
    >
      <Text fontSize="sm">
        {t("activity.labels.companyUpdated", {
          company: activity.trackable.name,
        })}
      </Text>
    </Activity>
  );
};
